import React, { useMemo } from 'react';
import { Placeholder as SemanticPlaceholder } from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
import cn from 'classnames';

export enum Colors {
	DEFAULT = 'background',
	WHITE = 'white',
}

interface ISkeletonProps {
	key?: string;
	lines?: number;
	backgroundColor?: Colors;
}

const createFullArray = (len: number, map: (i: number) => any): any[] => (
	new Array(len).fill(undefined).map((x, i) => map(i))
);

const Skeleton = ({
	key,
	lines: totalLines = 6,
	backgroundColor = Colors.DEFAULT,
}: ISkeletonProps) => {
	const [keys] = React.useState(createFullArray(totalLines, () => uuidv4()));

	const sets = useMemo(() => {
		if (totalLines <= 6) {
			return (
				<SemanticPlaceholder
					fluid
					className={cn('skeleton', backgroundColor)}
					key="container-1"
					data-testid="skeleton"
				>
					{createFullArray(totalLines, i => <SemanticPlaceholder.Line key={keys[i]} />)}
				</SemanticPlaceholder>
			);
		}

		const numberOfSets = Math.ceil(totalLines / 6);
		const result = createFullArray(numberOfSets, containerIndex => {
			const lines = containerIndex === (numberOfSets - 1)
				? createFullArray(totalLines % 6, i => <SemanticPlaceholder.Line key={keys[i]} />)
				: createFullArray(6, i => <SemanticPlaceholder.Line key={keys[i]} />);

			return (
				<SemanticPlaceholder
					fluid
					className={cn('skeleton', backgroundColor)}
					key={`container-${keys[containerIndex]}`}
					data-testid="skeleton"
				>
					{lines}
				</SemanticPlaceholder>
			);
		});

		return result;
	}, [backgroundColor, keys, totalLines]);

	return <div className="skeleton-component" key={key}>{sets}</div>;
};

export default Skeleton;
